import { render, staticRenderFns } from "./InstitutoSelecionado.vue?vue&type=template&id=61dc7282"
import script from "./InstitutoSelecionado.vue?vue&type=script&lang=js"
export * from "./InstitutoSelecionado.vue?vue&type=script&lang=js"
import style0 from "./InstitutoSelecionado.vue?vue&type=style&index=0&id=61dc7282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports